import PropTypes from 'prop-types';
import { useEffect } from 'react';

import Heading from 'shopper/components/Heading';
import Text from 'shopper/components/Text';

import CouponsList from 'components/Coupons/CouponsList';

import useMyBlackFridayScheduler from 'hooks/useMyBlackFridayScheduler';

import placeholder from 'lib/placeholder';
import { couponQueryKeys } from 'lib/queryKeys';
import { sendSupixEvent } from 'lib/supix';

import { getCouponsList } from 'services/coupon';
import { getStoreCouponsList } from 'services/store';

const CouponsListGameTab = ({ gaEventCategory }) => {
  const { getCampaignByType } = useMyBlackFridayScheduler();

  useEffect(() => {
    sendSupixEvent('/car', { category: 100010300 });
  }, []);

  const couponCampaign = getCampaignByType('COUPONS');

  const queryFn = couponCampaign
    ? ({ limit, page }, opts) =>
        getStoreCouponsList(
          { limit, page, storeSlug: couponCampaign.storeSlug },
          opts
        )
    : ({ limit, page }, opts) =>
        getCouponsList({ limit, after: page, sort: 'best' }, opts);

  const queryKey = couponCampaign
    ? couponQueryKeys.list({
        sortType: 'best',
        storeSlug: couponCampaign.storeSlug,
      })
    : couponQueryKeys.list({
        sortType: 'best',
      });

  return (
    <div>
      <Heading className="mb-2" size="size4">
        {placeholder('titles.bestCouponsGame')}
      </Heading>
      <Text className="mb-3">{placeholder('subtitles.bestCouponsBF')}</Text>
      <CouponsList
        className="mb-16"
        gaEventCategory={gaEventCategory}
        queryFn={queryFn}
        queryKey={queryKey}
        withCouponStoreCover
      />
    </div>
  );
};

CouponsListGameTab.propTypes = {
  gaEventCategory: PropTypes.string.isRequired,
};

export default CouponsListGameTab;
